import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const useSectionNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (e, hash) => {
    e.preventDefault();
    if (pathname === "/") scrollToId(hash.slice(1));
    else navigate(`/${hash}`);
  };
};

export const SectionLink = ({ hash, onClick, children, ...rest }) => {
  const go = useSectionNav();
  return (
    <a href={`/${hash}`} onClick={(e) => { onClick?.(); go(e, hash); }} {...rest}>
      {children}
    </a>
  );
};

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }
    const t = setTimeout(() => scrollToId(hash.slice(1)), 80);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};
